import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import { useAnalytics } from 'clientHelpers/context/analyticsContext'
import Collapsible from 'react-collapsible'

const QACard = ({ question, answer, sourceDetail }) => {
  const { addTrackingForCTA } = useAnalytics()

  const renderQuestionComponent = (
    <a
      {...addTrackingForCTA({
        action: 'Clicked FAQ',
        sourceDetail,
      })}>
      <div className={styles.question}>
        {question}
        <img className={styles.arrow} src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/faq_arrow_down.svg`} />
      </div>
    </a>
  )

  return (
    <div className={styles.qaCard}>
      <Collapsible transitionTime={250} trigger={renderQuestionComponent} triggerOpenedClassName={styles.rotateArrow}>
        <div className={styles.answer}>{answer}</div>
      </Collapsible>
    </div>
  )
}

QACard.propTypes = {
  answer: PropTypes.any,
  question: PropTypes.string,
  sourceDetail: PropTypes.string,
}

export default QACard
